enum LoadSuspensionReason {
    Alocacao_Frota_Fixa = 0,
    Reoferta_Carga = 1,
    Problema_Com_Transpotadora_Confirmada = 2,
    Informacoes_Incorretas = 3,
    Erro_Desconhecido = 4,
    Outro = 5,
}

export default LoadSuspensionReason;
